import React, { Fragment, useEffect, useState, useRef } from "react";
import ActionBar from "../../../common/ActionBar/index";
import theme from "../../../../assets/theme";
import styled from "styled-components";
import CustomTable from "../../../common/CustomTable/MaterialCustomTable";
import labels from "../../../../helpers/labels.json";
import { navigate, useLocation } from "@reach/router";
import COLORS from "../../../../assets/Colors";
import _ from "lodash";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../../helpers/functions";
import EventManagerService from "../../../../services/EventManagerService";
import moment from "moment";

const ViewEvents = () => {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [selectedFilter, setSelectedFilter] = useState();
  const location = useLocation();
  const orgId = location?.state?.orgId;
  const hostId = location?.state?.hostId;
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  const DateAndTime = (utcTime, time) => {
    const istTime = new Date(utcTime);

    // Format the date with AM/PM in the specified format
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedTime = istTime.toLocaleString("en-IN", options);

    // Extract date components for custom formatting
    const [rawDate] = formattedTime.split(", ");

    // Format date using periods (.)
    const formattedDate = rawDate.replace(/\//g, ".");
    time = moment(time, "HH:mm:ss");

    const formattedTimeUppercase = moment(`${time}`).format("hh:mm A");
    // Custom format for output
    const formattedOutput = `${formattedDate} | ${formattedTimeUppercase}`;
    return formattedOutput;
  };

  const columns = [
    {
      field: "eventName",
      title: labels.events_name,
      sorting: true,
      render: (rowData) => <Center>{rowData.eventName}</Center>,
      width: 190,
    },
    {
      field: "date",
      title: labels.data_and_time,
      sorting: false,
      render: (rowData) => (
        <Center>{DateAndTime(rowData.date, rowData?.startTime)}</Center>
      ),
      width: 260,
    },
    {
      field: "streamingUrl",
      title: "Url Sub domain",
      sorting: true,
      render: (rowData) => <Center>{rowData.streamingUrl}</Center>,
    },
    {
      field: "status",
      title: labels["host-status"],
      sorting: false,
      render: (rowData) => (
        <Center style={{ color: "#006400" }}>{rowData?.status}</Center>
      ),
    },
  ];

  useEffect(() => {
    async function getMappedEvents() {
      try {
        const time = moment(new Date()).format("HH:mm");
        const response = await EventManagerService.getMappedEvents(
          orgId,
          hostId,
          time
        );
        setState({ data: response.mappedevents });
      } catch (error) {
        setState({ state: [] });
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoading(false);
      }
    }
    getMappedEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "view_organisation":
        navigate(`/dashboard/event-host`);
        break;
      case "view_hosts":
        navigate(`/dashboard/event-host/view-hosts`, {
          state: {
            orgId: orgId,
          },
        });
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <ActionBar
        breadcrumbs={[
          "View Organisation",
          "View Hosts",
          "View Events Mapped to host",
        ]}
        {...{ onBreadcrumbClick }}
      />
      {/* <Heading>View Hosts</Heading> */}
      <Padding>
        <CustomTable
          hidePagination={state?.lastPage === 1}
          pageSize={state?.length ? state?.length : 10}
          pluralTitle={"Events"}
          singularTitle={"Events"}
          placeholderText={"Search"}
          noToolbar={true}
          {...{
            columns,
            selectedFilter,
            setSelectedFilter,
            MTRef,
          }}
          loading={loading}
          data={state?.data}
          hideFilterBar
          state={state}
        />
      </Padding>
    </Fragment>
  );
};

export default ViewEvents;

const Padding = styled.div`
  // padding: 30.3px 15px 15.7px 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 10px;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 53px;
  }
`;

export const HeadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
`;

export const ActionButton = styled.button`
  border: none;
  background: none;
  outline: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 12px;
`;

const Center = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #454545;
  font-weight: 600;
`;

export const HyperLink = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  text-decoration: underline;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "0px")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const Heading = styled.span`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${theme.fonts.primaryFontExtraBold};
  font-size: 18px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
`;
